import { BUILDER_SYNC_STATUS } from '@/courses/values/courses.values';
import { EdContextMenuOptionsModel } from '@/plugins/ed-context-menu/ed-context-menu.plugin';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({})
class EdCardComponent extends Vue {

  @Prop() readonly img: string;
  @Prop() readonly iconFooter: string;
  @Prop() readonly iconFooterTooltip: string;
  @Prop() readonly title: string;
  @Prop() readonly subtitle: string;
  @Prop() readonly tag: string;
  @Prop() readonly label: string;
  @Prop() readonly loading: boolean;
  @Prop() readonly overMenu: EdContextMenuOptionsModel[];
  @Prop() readonly listMenu: EdContextMenuOptionsModel[];
  @Prop() readonly onOverMenuSelected: Function;
  @Prop() readonly onListMenuSelected: Function;
  @Prop() readonly hasBorder: boolean;
  @Prop() readonly hasProgressBar: boolean;
  @Prop() readonly progressLabel: string;
  @Prop({ default: 'var(--ed-color-main)' }) readonly progressColor: string;
  @Prop() readonly disabled: boolean;
  @Prop() readonly draftTag: boolean;
  @Prop() readonly conflictTag: boolean;
  @Prop({ default: '' }) readonly statusSync: string;

  public isOverMenuVisible: boolean = false;

  get coverStyle() {
    if(this.img) {
      return { 'background-image' : `url(${this.img})` };
    } else {
      return { 'background-color': 'var(--ed-color-gray-lighter-middle)' };
    }
  }

  get statusSyncOut() {
    return this.statusSync === BUILDER_SYNC_STATUS.OUT;
  }
  
  get statusSyncPending() {
    return this.statusSync === BUILDER_SYNC_STATUS.PENDING;
  }

  get statusSyncDone() {
    return this.statusSync === BUILDER_SYNC_STATUS.DONE;
  }

  get statusSyncProcess() {
    return this.statusSync === BUILDER_SYNC_STATUS.PROCESS;
  }

  get statusSyncReadyDownload() {
    return this.statusSync === BUILDER_SYNC_STATUS.READY_DOWNLOAD;
  }

  get statusSyncUplaoding() {
    return this.statusSync === BUILDER_SYNC_STATUS.UPLOADING;
  }

  get cardClasses() {
    return {
      'ed-card--disabled': this.disabled,
      'ed-card--border': this.hasBorder,
    };
  }

  openOverMenu() {
    this.isOverMenuVisible = true;
  }

  hideOverMenu() {
    this.isOverMenuVisible = false;
  }

  selectOverMenu(menu) {
    this.$emit('onOverMenuSelected', menu);
  }

  setMenuSelected(optionSelected: EdContextMenuOptionsModel) {
    this.$emit('onListMenuSelected', optionSelected);
  }

}
export default Vue.component('ed-card', EdCardComponent);